<template>
  <nav class="main-menu" :class="{ 'is-open': mainMenuDisplay }">
    <span class="main-menu_name">Menu</span>
    <button
      class="main-menu-close"
      :class="{ 'is-open': mainMenuDisplay }"
      @click="$emit('update:mainMenuDisplay', !mainMenuDisplay)"
    ></button>

    <ul class="main-menu-list">
      <li class="main-menu-list_item mb-8 mt-8" @click="toggleMainMenu">
        <router-link :to="{ name: 'home' }" title="Accéder à la page d'accueil">
          <span>Accueil</span>
        </router-link>
      </li>

      <li class="main-menu-list_item mb-8 mt-8">
        <span class="rub-intitule">Recherche Rapide</span>
        <ul class="sous-rub">
          <li class="sous-rub_item" @click="toggleMainMenu">
            <router-link
              :to="{ name: 'products' }"
              title="Accéder à l'annuaire complet des produits"
            >
              <span>Produits</span>
            </router-link>
          </li>
          <li class="sous-rub_item" @click="toggleMainMenu">
            <router-link
              :to="{ name: 'substances' }"
              title="Accéder à l'annuaire complet des substances actives & macro-organismes"
            >
              <span>Substances actives & macro-organismes</span>
            </router-link>
          </li>
        </ul>
      </li>

      <li class="main-menu-list_item mb-8 mt-8">
        <span class="rub-intitule">Recherche avancée</span>
        <ul class="sous-rub">
          <li class="sous-rub_item" @click="toggleMainMenu">
            <router-link
              :to="{ name: 'productsAdvancedSearch' }"
              title="Accéder à la recherche avancée des produits"
            >
              <span>Produits</span>
            </router-link>
          </li>
          <li class="sous-rub_item" @click="toggleMainMenu">
            <router-link
              :to="{ name: 'substancesAdvancedSearch' }"
              title="Accéder à la recherche avancée des substances actives"
            >
              <span>Substances actives & macro-organismes</span>
            </router-link>
          </li>
        </ul>
      </li>

      <li class="main-menu-list_item mb-8 mt-8" @click="toggleMainMenu">
        <router-link
          :to="{ name: 'news' }"
          title="Accéder à la liste des actualités"
        >
          <span>Actualités</span>
        </router-link>
      </li>

      <li class="main-menu-list_item mb-8 mt-8">
        <router-link
          :to="{ path: knowEverythingAboutCropsUrl }"
          title="Accéder à l'annuaire complet des produits"
        >
          <span>Tout savoir sur la protection des cultures</span>
        </router-link>
      </li>
    </ul>

    <ul class="second-menu-footer">
      <hr />
      <li
        v-for="(item, i) in menuLinks"
        class="second-menu-footer_item"
        :key="i"
        @click="toggleMainMenu"
      >
        <router-link :to="{ path: item.link }" :title="item.title">
          {{ item.name }}
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import { knowEverythingAboutCropsUrl } from "@/include/urls";

export default {
  name: "MainMenu",

  props: {
    mobile: Boolean,
    mainMenuDisplay: Boolean,
    menuLinks: Array,
  },

  data() {
    return {
      knowEverythingAboutCropsUrl: knowEverythingAboutCropsUrl,
    };
  },

  methods: {
    toggleMainMenu() {
      if (this.mobile) {
        this.$emit("update:mainMenuDisplay", !this.mainMenuDisplay);
      }
    },
  },
};
</script>
